import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Alert from "@material-ui/lab/Alert";
import TextInputGroup from "../molecules/text_input_group";
import { fetchUser } from "../../actions";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../hooks/useConfig";

const AddRedmineForm = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [errorMessage, setErrorMessage] = useState({ message: null });
  const [redmineurl, setRedmineurl] = useState("");
  const [apikey, setApikey] = useState("");
  const { createConfig } = useConfig();
  const unCreatable = name === "" || redmineurl === "" || apikey === "";
  const { t } = useTranslation();
  const handleClickOpenWindow = () => setOpen(true);
  const handleClickCloseWindow = () => setOpen(false);
  const handleExited = () => {
    setErrorMessage({ message: null });
    setName("");
    setRedmineurl("");
    setApikey("");
  };
  const handleClickCreateConfig = async () => {
    let res = null;

    // 末尾に'/'があるかチェックし、'/'がない場合は末尾に追加する。
    let url;
    let reg = /https?\:\/\/.+\/$/;
    if (reg.test(redmineurl)) {
      url = redmineurl;
    } else {
      url = redmineurl + "/";
    }

    try {
      res = await fetchUser(apikey, url);
    } catch (err) {
      console.log(err);
    }
    if (res) {
      await createConfig({
        name,
        apikey,
        redmineurl: url,
      });
      handleClickCloseWindow();
      handleExited();
    } else {
      setErrorMessage({ message: t("home.error_invalid_url_or_key") });
    }
  };
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={(e) => handleClickOpenWindow()}
      >
        {t("home.button_add_redmine")}
      </Button>

      <Dialog
        fullWidth
        maxWidth={"md"}
        open={open}
        onClose={handleClickCloseWindow}
        onExited={handleExited}
        aria-labelledby="max-width-dialog-title"
      >
        <form noValidate>
          <DialogTitle
            id="max-width-dialog-title"
            style={{ backgroundColor: theme.palette.secondary.main }}
          >
            <Box
              component={Typography}
              variant="h3"
              paddingTop="1rem"
              paddingBottom="1rem"
              letterSpacing=".04em"
            >
              {t("home.label_redmine_config")}
            </Box>
          </DialogTitle>
          <DialogContent
            style={{ backgroundColor: theme.palette.secondary.main }}
          >
            {errorMessage.message && (
              <Alert severity="error" style={{ margin: 20 }}>
                {errorMessage.message}
              </Alert>
            )}
            <Grid container>
              <Grid item xs={12}>
                <TextInputGroup
                  label={t("home.field_redmine_name")}
                  value={name}
                  onChange={setName}
                  placeholder="例：My Redmine（任意の名前）"
                />
              </Grid>
              <Grid item xs={12}>
                <TextInputGroup
                  label={t("home.field_redmine_url")}
                  value={redmineurl}
                  onChange={setRedmineurl}
                  placeholder="例：https://www.example.com"
                />
              </Grid>
              <Grid item xs={12}>
                <TextInputGroup
                  label={t("home.field_redmine_key")}
                  value={apikey}
                  onChange={setApikey}
                  placeholder="例：df4a97027135e0fcf1fd2f2ebe79a17cdda4e2a928ad1b4b0ab0166ddcdfafa8"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            style={{ backgroundColor: theme.palette.secondary.main }}
          >
            <Button onClick={handleClickCloseWindow} color="primary" autoFocus>
              {t("button_cancel")}
            </Button>
            <Button
              onClick={(e) => handleClickCreateConfig()}
              variant="contained"
              color="primary"
              disabled={unCreatable}
            >
              {t("button_save")}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
export default AddRedmineForm;
